import styled from "styled-components";
import { ButtonTitle } from "features/shared/styles/typography/ButtonTitle.styled";

const StyledLinkButton = styled.a`
  display: inline-block;
  color: ${({ theme }) => theme.colors.primary1};
  text-decoration: none;
  border-bottom: 1px solid
    ${({ theme }) =>
      theme.linkUnderlined ? theme.colors.primary1 : "transparent"};
  padding-bottom: 4px;

  img {
    display: inline-block;
    vertical-align: text-bottom;
  }

  img:first-child {
    transform: rotate(180deg);
    margin-right: 8px;
  }

  img:last-child {
    margin-left: 8px;
  }

  ${ButtonTitle} {
    color: ${({ theme }) => theme.colors.primary1};
  }
`;

export default StyledLinkButton;
